class PhoneFormatter {
  format(value) {
    if (!value) {
      return value;
    }
    const filterSpaces = value => {
      return value.replace(/ /g, '');
    };
    const filterUnwantedCharacters = value => {
      return value.replace(/[^+0-9]/g, '');
    };
    const filteredValue = filterSpaces(filterUnwantedCharacters(value));
    const countryPrefix = filteredValue.substring(0, 3).trim();
    const prefix = filteredValue.substring(3, 5).trim();
    const threeNumbers = filteredValue.substring(5, 8).trim();
    const firstPair = filteredValue.substring(8, 10).trim();
    const secondPair = filteredValue.substring(10, 12).trim();
    const appendix = filteredValue.substring(12).trim();
    let newValue = '';
    if (countryPrefix) {
      newValue += countryPrefix;
    }
    if (prefix) {
      newValue += ` ${prefix}`;
    }
    if (threeNumbers) {
      newValue += ` ${threeNumbers}`;
    }
    if (firstPair) {
      newValue += ` ${firstPair}`;
    }
    if (secondPair) {
      newValue += ` ${secondPair}`;
    }
    if (appendix) {
      newValue += ` ${appendix}`;
    }
    return newValue;
  }
}
const phoneFormatter = new PhoneFormatter();
export default phoneFormatter;